import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'lib-horizontal-divider',
  imports: [],
  template: `
    <div class="custom-divider" role="separator">
      <span class="divider-line left"></span>
      @if (text()) {
        <span class="divider-text">{{ text() }}</span>
      }
      <span class="divider-line right"></span>
    </div>
  `,
  styles: `
    .custom-divider {
      display: flex;
      align-items: center;
      text-align: center;
    }
    .divider-line {
      flex-grow: 1;
      height: 1px;
      background-color: rgba(0, 0, 0, 0.12);
    }
    .divider-text {
      font-size: 14px;
      padding: 0 10px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HorizontalDividerComponent {
  text = input<string | undefined>();
}
